// import JSZip from 'jszip'
import saveAs from 'file-saver'
const version = require('@/../package').version

function exportDb (measurments) {
  return new Promise((resolve, reject) => {
    var date = new Date()
    var dateString = date.toISOString()
    var exportDb = {
      info: {
        version: 'arcadia-v' + version,
        timestamp: dateString
      },
      plots: {}
    }

    measurments.iterate((value, key, iterationNumber) => {
      exportDb.plots[key] = value
    }).then(function () {
      /* var zip = new JSZip()
      zip.file('plots.json', JSON.stringify(exportDb))
      zip.generateAsync({ type: 'blob' }).then(function (content) {
        saveAs(content, 'exportDb-' + dateString + '.zip')
      }) */
      var blob = new Blob([JSON.stringify(exportDb)], { type: 'application/json' })
      saveAs(blob, 'plots-' + dateString + '.json')
      resolve()
    }).catch(function (err) {
      reject(new Error('Export failed'))
      console.log(err)
    })
  })
}

export default exportDb
